import React, { useState } from 'react';
import moment from 'moment-timezone';
import { useClinicianSlots } from 'vl-core/getSlotBuckets';
import { AppointmentSlot } from '../../types';
import { SlotGrid, SlotGridSkeleton } from './SlotGrid';
import type { Clinician } from 'vl-common/src/schemas/getCliniciansClinicians';
import { BookingData } from '../../lib/context/BookingContext/bookingTypes';
import { useBookingFlowData } from '../../hooks/useBookingFlowData';

type DisplayAvailableSlotsProps = {
  clinician: Clinician;
  onSelectClinicianSlot: ({ apptDate, clinician }: Pick<BookingData, 'apptDate' | 'clinician'>) => void;
  timezone: string;
};

const DisplayAvailableSlots = ({ clinician, onSelectClinicianSlot, timezone }: DisplayAvailableSlotsProps) => {
  const { bookingData, caseData } = useBookingFlowData();

  moment.tz.setDefault(timezone);
  const [weekCount, setWeekCount] = useState(0);

  const filteredBucket = useClinicianSlots(
    weekCount,
    bookingData?.clinType || '',
    [caseData?.case_spec_area_code ?? ''],
    bookingData?.patientId || '',
    clinician?.clin_user_guid,
    caseData?.spec_cat_code || '',
    bookingData?.apptType || '',
    bookingData?.apptAuthFromDate || null,
    bookingData?.apptAuthEndDate || null
  );

  const handleSelectEvent = (selectedSlot: AppointmentSlot) => {
    onSelectClinicianSlot({
      apptDate: new Date(selectedSlot.start),
      clinician: {
        id: clinician.clin_user_guid,
        name: `${clinician.first_name} ${clinician.last_name}`,
        type: clinician.subtype_desc
      }
    });
  };

  return (
    <div data-testid="displayavailableslots-component">
      {!filteredBucket ? (
        <SlotGridSkeleton />
      ) : (
        <SlotGrid
          slots={filteredBucket?.buckets || []}
          clinician={clinician}
          timezone={timezone}
          weekCount={weekCount}
          setWeekCount={setWeekCount}
          selectSlot={handleSelectEvent}
          startDate={filteredBucket?.startDay || null}
        />
      )}
    </div>
  );
};

export default DisplayAvailableSlots;
